import { render } from "./StaffAttendanceList.vue?vue&type=template&id=6a0317f9&ts=true"
import script from "./StaffAttendanceList.vue?vue&type=script&lang=ts"
export * from "./StaffAttendanceList.vue?vue&type=script&lang=ts"

import "./StaffAttendanceList.vue?vue&type=style&index=0&id=6a0317f9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__